module.exports = __webpack_public_path__ + "teqbahn-assets/media/O_photoCropped.4467ad4a.jpg";